// extracted by mini-css-extract-plugin
export default {"sidepanels":"lsf-sidepanels","sidepanels__content":"lsf-sidepanels__content","sidepanels__wrapper":"lsf-sidepanels__wrapper","sidepanels__wrapper_snap":"lsf-sidepanels__wrapper_snap","sidepanels__wrapper_align_left":"lsf-sidepanels__wrapper_align_left","sidepanels__wrapper_align_right":"lsf-sidepanels__wrapper_align_right","sidepanels_collapsed":"lsf-sidepanels_collapsed","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630374444
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  